import React, { Component, useState, useEffect } from 'react';
import ManageResource from './ManageResource';
import ManageFields from './ManageFields';
import { Modal, Button, Space, Select, Form, Input, Switch, Tooltip, Popover, Spin, Pagination } from 'antd';
import {
    CopyOutlined,
    MoreOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    LoadingOutlined,
    CheckCircleTwoTone,
    CheckOutlined,
    CloseOutlined,
    WarningTwoTone,
    WarningOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    FieldTimeOutlined,
    ControlOutlined,
    EditOutlined,
} from '@ant-design/icons';
import CommonTable from '../../commonComponents/Table/table';
import { useListingCompanies } from '../../hooks/useCompanies';
import SelectCompanyCode from './SelectCompany';
import stc from 'string-to-color';
import InputList from '../../commonComponents/InputList';
import {
    useGetPlanningResource,
    useGetCSVFieldsList,
    useUpdatePlanningResource,
    useGetPlanningPendency,
    useCreateMergeGuidelineFromPlanning,
    useGetPlanningPendencyForBSTWithCSVData,
} from '../../hooks/usePlanning';
import { useQuery } from 'react-query';
import ShowPendency from './ShowPendency';
import CreateGuidelines from './CreateGuidelines';
import { useNavigate } from 'react-router-dom';
import {
    fetchAllOrders,
    piRequestReject,
    piRequestSuccess,
    useDownloadPII,
    fetchNotificationsForOrder,
    useDownloadCC,
    useGenerateInboundReport,
} from '../../hooks/useOrders';

export default function Planning({ excludedLinks = null }) {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const { data: companyCodeList } = useListingCompanies();
    const [showManageModel, setShowManageModel] = useState(false);
    const [showManageBays, setShowManageBays] = useState(false);
    const [showEditFields, setShowEditFields] = useState(false);
    const [showPendency, setShowPendency] = useState(false);
    const [showAddLink, setShowAddLink] = useState(false);
    const [companyCode, setCompanyCode] = useState(null);
    const [apiData, setApiData] = useState({
        splitByShootType: true,
        splitByOrder: true,
        includePendingAtRawQC: false,
        showOnlyDDApproved: false,
        showCSA: false,
        splitByPresets: false,
    });
    const [orderTableData, setOrderTableData] = useState([]);

    const {
        data: ModelsList,
        isFetching: isFetchingplaceHolderModels,
        isFetched: isFetchedplaceHolderModels,
        refetch: refetchplaceHolderModels,
    } = useGetPlanningResource(companyCode, 'Models');

    const {
        data: BaysList,
        isFetching: isFetchingBays,
        isFetched: isFetchedBays,
        refetch: refetchBays,
    } = useGetPlanningResource(companyCode, 'Bays');

    const CreateMergeGuidelineFromPlanningMutation = useCreateMergeGuidelineFromPlanning();
    const GetPlanningPendencyForBSTWithCSVDataMutation = useGetPlanningPendencyForBSTWithCSVData();

    const HandleGuidelineCreation = guidelines => {
        CreateMergeGuidelineFromPlanningMutation.mutateAsync({ guidelines, companyCode })
            .then(() => {
                alert('Success');
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                navigate('/guidelines');
            });
    };

    const oncompanyCodeChange = text => {
        setCompanyCode(text);
    };

    const HandleCalculatePendency = data => {
        console.log(data);
        setApiData(data);
        setShowPendency(true);
    };

    const onSuccessOrder = data => {
        setOrderTableData(data?.data);
    };

    const OrderError = err => {
        // if (err?.response?.status === 401) logout();
    };

    const [selectedOrders, setSelectedOrders] = useState(null);
    const [showOrderModal, setShowOrderModal] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [companyCodeText, setCompanyCodeText] = useState('');
    const [orderId, setOrderId] = useState('');
    const [orderData, setOrderData] = useState([]);
    const [StageNames, setStageNames] = useState({});
    const [postProdColumnsToRemove, setPostProdColumnsToRemove] = useState([]);

    const HandleDownloadXlsx = async () => {
        const formData = form.getFieldsValue(['ExcludeLinks', 'includePendingAtRawQC', 'includeSpecialCategory', 'showOnlyDDApproved', 'showCSA']);
        console.log({ formData });
        const response = await GetPlanningPendencyForBSTWithCSVDataMutation.mutateAsync([
            formData?.ExcludeLinks,
            companyCode,
            formData?.includePendingAtRawQC,
            formData?.includeSpecialCategory,
            selectedOrders,
            formData?.showOnlyDDApproved,
            formData?.showCSA,
        ]);
        // console.log({ response });
        setShowOrderModal(false);
        setSelectedOrders(null);
    };

    const getTimeComparision = timeStamp => {
        return `${new Date(timeStamp).toLocaleTimeString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        })} `;
    };
    const getIncrementDecrementColor = (value, remark) => {
        return value > 0 ? (remark === 'pending' ? '#F29339' : '#52c41a') : remark === 'pending' ? '#52c41a' : '#F29339';
    };
    const getArrowSign = (value, remark) => {
        return value > 0 ? (
            <ArrowUpOutlined
                style={{
                    color: remark === 'pending' ? '#F29339' : '#52c41a',
                    margin: 0,
                    padding: 0,
                }}
            />
        ) : (
            <ArrowDownOutlined
                style={{
                    color: remark === 'pending' ? '#52c41a' : '#F29339',
                    margin: 0,
                    padding: 0,
                }}
            />
        );
    };
    const getIncrementDecrement = (value, remark) => {
        if (value !== 0) {
            return (
                <span
                    style={{
                        color: getIncrementDecrementColor(value, remark),
                        margin: 0,
                        padding: 0,
                    }}
                >
                    {`(`}
                    {getArrowSign(value, remark)}
                    {Math.abs(value)}
                    {`)`}
                </span>
            );
        }

        return null;
    };
    const stageStatusView = (status, timeStamp) => {
        const f = `pending: ${status?.pending} completed: ${status?.completed}`;
        const title = (
            <>
                {status?.pending > 0 && (
                    <div>
                        <span style={{ color: '#F29339', fontSize: '20px', position: 'relative' }}>
                            {`😟 pending: ${status?.pending} `}
                            {getIncrementDecrement(status?.pendingDiff, 'pending')}
                        </span>
                        <br />
                    </div>
                )}
                {status?.completed > 0 && (
                    <div>
                        {' '}
                        <span style={{ color: '#52c41a', fontSize: '20px' }}>
                            {`🤩 completed: ${status?.completed} `}
                            {getIncrementDecrement(status?.completedDiff, 'complete')}
                        </span>
                        <br />
                    </div>
                )}

                <div>
                    <span style={{ color: '#3c8cd2', fontSize: '20px' }}>{`🙂 total: ${status?.completed + status?.pending}`}</span>
                </div>
                {timeStamp && (
                    <div>
                        <span style={{ color: '#FCE09B', fontSize: '14px', paddingLeft: '4px' }}>
                            <ControlOutlined style={{ fontSize: '16px' }} />
                            {'  '}
                            {`${getTimeComparision(timeStamp)}`}
                        </span>
                    </div>
                )}
            </>
        );
        if (status.pending == 0 && status.completed == 0) {
            return <></>;
        } else if (status.pending > 0 && status.completed == 0) {
            return (
                <>
                    <Tooltip title={title} placement="topRight">
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <span style={{ color: '#F29339', fontSize: '16px' }}>
                                <ClockCircleOutlined />
                                {' ' + status?.pending}
                            </span>
                        </div>
                    </Tooltip>
                </>
            );
        } else if (status.pending == 0 && status.completed > 0) {
            return (
                <Tooltip title={title} placement="topRight">
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '32px' }} />
                    </div>
                </Tooltip>
            );
        } else if (status.pending > 0 && status.completed > 0) {
            return (
                <>
                    <Tooltip title={title} placement="topRight">
                        <span style={{ color: '#F29339', fontSize: '16px' }}>
                            <ClockCircleOutlined />
                            {' ' + status?.pending}
                        </span>
                        <br />
                        <span style={{ color: 'darkgreen', fontSize: '16px' }}>
                            <CheckCircleOutlined />
                            {' ' + status?.completed}
                        </span>
                    </Tooltip>
                </>
            );
        }
    };

    const {
        refetch: fetchOrders,
        data: orders,
        isFetching,
        isError,
    } = useQuery(['listing', pageNumber, pageSize, companyCode], fetchAllOrders, {
        refetchOnWindowFocus: true,
        onSuccess: onSuccessOrder,
        onError: OrderError,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });

    useEffect(() => {
        setOrderData(orders);
        orders?.data?.StageNames && setStageNames(orders?.data?.StageNames);
        orders?.data?.PostProductionStages && setPostProdColumnsToRemove(orders?.data?.PostProductionStages);
    }, [orders]);

    const spinIcon = (
        <div className="spin-center">
            <Spin className="spin_loader" size="large" />{' '}
        </div>
    );
    const stageColumns = [];
    Object.keys(StageNames).forEach(stage => {
        stageColumns.push({
            title: StageNames[stage],
            // dataIndex: 'stage',
            key: StageNames[stage],
            align: 'center',
            render: (_, record) => {
                const status = record?.status?.find(d => d.stage === stage);
                const timeStamp = record?.orderSnapshotTimestamp || '';
                return <span>{status && stageStatusView(status, timeStamp)}</span>;
            },
        });
    });

    const column = [
        {
            title: 'Batch No',
            // dataIndex: 'batchNo',
            key: '_id',
            render: (_, record) => {
                return <div>{record?.batchNo}</div>;
            },
        },
        {
            title: 'Company Code',
            // dataIndex: 'companyCode',
            key: '_id',
            render: (_, record) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            flexDirection: 'row',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: stc(record?.companyCode),
                                width: '10px',
                                height: '50px',
                                // border: "1px solid #000",
                                marginRight: '15px',
                            }}
                        ></div>
                        <span>
                            <b>{record?.companyCode}</b>
                        </span>
                    </div>
                );
            },
        },
        {
            title: 'Order Name',
            // dataIndex: 'name',
            key: '_id',
            render: (_, record) => {
                return (
                    <div>
                        {!!record?.notificationCount && record?.notificationCount > 0 && (
                            <Button
                                danger
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '5px',
                                }}
                                onClick={() => {
                                    console.log(record?._id);
                                    setOrderId(record?._id);
                                    // refetchNotifications();
                                    // setShowNotificationModal(true);
                                }}
                            >
                                <p>
                                    <WarningOutlined />
                                    {record?.notificationCount}
                                </p>
                            </Button>
                        )}
                        {record?.name && (
                            <b>
                                <span>{record.name}</span>
                            </b>
                        )}
                        <br />
                        {record?.createdBy?.name && (
                            <span
                                style={{
                                    fontWeight: '100',
                                    fontSize: '11px',
                                }}
                            >
                                Created by: {record?.createdBy?.name}
                            </span>
                        )}
                        <br />
                        {record?.createdAt && (
                            <i>
                                <span
                                    style={{
                                        fontWeight: '100',
                                        fontSize: '11px',
                                    }}
                                >
                                    {record.createdAt &&
                                        new Date(record.createdAt).toLocaleDateString('en-US', {
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                        })}
                                </span>
                            </i>
                        )}
                        <br />
                        {record?.studios?.map((studio, i) => {
                            return (
                                <span
                                    key={i}
                                    style={{
                                        fontWeight: '100',
                                        fontSize: '11px',
                                    }}
                                >
                                    {`${studio.studioName}(${studio.studioCode})`}
                                </span>
                            );
                        })}
                    </div>
                );
            },
        },
        ...stageColumns,
        // {
        //     title: '',
        //     dataIndex: '',
        //     key: 'x',
        //     fixed: 'right',
        //     width: '50px',
        //     render: (_, record) => {
        //         const showPiResult = record?.piiReopenRequests?.some(item => !!item.requestOpen);
        //         return (
        //             <div className="icon_legend">
        //                 <Popover placement="left" content={<Content props={record} />}>
        //                     <Button size="small" type="default">
        //                         <MoreOutlined />
        //                     </Button>
        //                 </Popover>
        //                 {showPiResult && <Badge status="warning" />}
        //             </div>
        //         );
        //     },
        // },
    ];

    // let columnToShow = [...column];

    return (
        <>
            {!companyCode ? (
                <SelectCompanyCode onCompanyCodeSelected={oncompanyCodeChange} />
            ) : (
                <>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '5px',
                        }}
                    >
                        <Space
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <h2>{companyCode}</h2>
                            <Button onClick={() => setCompanyCode(null)}>
                                <EditOutlined />
                            </Button>
                        </Space>
                        <Space>
                            <Button type="primary" onClick={() => setShowManageModel(true)}>
                                Manage Model
                            </Button>
                            <Button type="primary" onClick={() => setShowManageBays(true)}>
                                Manage Bays
                            </Button>
                            <Button type="primary" onClick={() => setShowEditFields(true)}>
                                Manage Fields
                            </Button>
                        </Space>
                    </div>
                    <hr />

                    <Form form={form} onFinish={HandleCalculatePendency}>
                        {/* <Form.Item label="Models To Calculate" name="selectedModels">
                            <div
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                }}
                            >
                                <Select
                                    allowClear
                                    mode="multiple"
                                    maxTagCount={3}
                                    options={ModelsList?.data?.map(model => {
                                        return {
                                            label: model?.name,
                                            value: model?.name,
                                            data: model,
                                        };
                                    })}
                                    onChange={(value, array) => {
                                        console.log({ value, array });
                                        form.setFieldValue(
                                            'selectedModels',
                                            array.map(d => d.data)
                                        );
                                    }}
                                />
                                <Button type="primary" onClick={() => setShowManageModel(true)}>
                                    Manage Model
                                </Button>
                            </div>
                        </Form.Item>
                        <Form.Item label="Bays To Calculate" name="selectedBays">
                            <div
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                }}
                            >
                                <Select
                                    allowClear
                                    mode="multiple"
                                    maxTagCount={3}
                                    options={BaysList?.data?.map(bay => {
                                        return {
                                            label: bay?.name,
                                            value: bay?.name,
                                            data: bay,
                                        };
                                    })}
                                    onChange={(value, array) => {
                                        console.log({ value, array });
                                        form.setFieldValue(
                                            'selectedBays',
                                            array.map(d => d.data)
                                        );
                                    }}
                                />
                                <Button type="primary" onClick={() => setShowManageBays(true)}>
                                    Manage Bays
                                </Button>
                            </div>
                        </Form.Item> */}
                        <Form.Item label="Exclude from Links" name="ExcludeLinks" colon={true}>
                            <InputList
                                UpdateItems={links => {
                                    form.setFieldValue(
                                        'ExcludeLinks',
                                        links.filter(d => d != '')
                                    );
                                }}
                            />
                        </Form.Item>
                        <Form.Item label="Split By Shoot Type" name="splitByShootType" initialValue={true}>
                            <Switch defaultChecked={true} />
                        </Form.Item>
                        <Form.Item label="Split By TAT Remaining" name="showSLAPending" initialValue={true}>
                            <Switch defaultChecked={true} />
                        </Form.Item>
                        <Form.Item label="Split By Order Name" name="splitByOrder" initialValue={true}>
                            <Switch defaultChecked={true} />
                        </Form.Item>
                        <Form.Item label="Split By Assigned Model" name="splitByAssignedModel" initialValue={false}>
                            <Switch defaultChecked={false} />
                        </Form.Item>
                        <Form.Item label="Include Special Category" name="includeSpecialCategory" initialValue={false}>
                            <Switch defaultChecked={false} />
                        </Form.Item>

                        <Form.Item label="Include Pending At RawQC" name="includePendingAtRawQC" initialValue={false}>
                            <Switch defaultChecked={false} />
                        </Form.Item>
                        <Form.Item label="Show Only DD Approved" name="showOnlyDDApproved" initialValue={false}>
                            <Switch defaultChecked={false} />
                        </Form.Item>
                        <Form.Item label="Show CSA" name="showCSA" initialValue={false}>
                            <Switch defaultChecked={false} />
                        </Form.Item>
                        <Form.Item label="Split By Days Since Inbound" name="splitByDaysSinceInbound" initialValue={false}>
                            <Switch defaultChecked={false} />
                        </Form.Item>
                        <Form.Item label="Split By Presets" name="splitByPresets" initialValue={false}>
                            <Switch defaultChecked={false} />
                        </Form.Item>
                        <Form.Item
                            label="Enter Plan Date"
                            name="dateString"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter the date for which you are planning shoot.',
                                    type: 'string',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Button block type="primary" htmlType="submit" hidden={true}>
                                Calculate Pendency
                            </Button>
                        </Form.Item>
                    </Form>
                    <Button block type="primary" onClick={() => setShowOrderModal(true)}>
                        Get Combined Pendency
                    </Button>
                </>
            )}
            {!!showManageModel && (
                <Modal
                    width={'100%'}
                    style={{
                        top: '0px',
                        height: '100%',
                    }}
                    open={showManageModel}
                    onCancel={() => {
                        setShowManageModel(false);
                        refetchplaceHolderModels();
                    }}
                    onOk={() => {
                        setShowManageModel(false);
                        refetchplaceHolderModels();
                    }}
                    footer={null}
                >
                    <ManageResource companyCode={companyCode} type="Models" />
                </Modal>
            )}
            {!!showManageBays && (
                <Modal
                    width={'100%'}
                    style={{
                        top: '0px',
                        height: '100%',
                    }}
                    open={showManageBays}
                    onCancel={() => {
                        setShowManageBays(false);
                        refetchBays();
                    }}
                    onOk={() => {
                        setShowManageBays(false);
                        refetchBays();
                    }}
                    footer={null}
                >
                    <ManageResource companyCode={companyCode} type="Bays" />
                </Modal>
            )}
            {!!showEditFields && (
                <Modal
                    width={'100%'}
                    style={{
                        top: '20px',
                        height: '100%',
                    }}
                    open={showEditFields}
                    onCancel={() => setShowEditFields(false)}
                    onOk={() => setShowEditFields(false)}
                    footer={null}
                >
                    <ManageFields companyCode={companyCode} />
                </Modal>
            )}
            {!!showPendency && (
                <CreateGuidelines
                    open={showPendency}
                    onCancel={() => setShowPendency(false)}
                    onOk={data => {
                        HandleGuidelineCreation(data);
                        setShowPendency(false);
                    }}
                    companyCode={companyCode}
                    ExcludeLinks={apiData?.ExcludeLinks}
                    selectedModels={apiData?.selectedModels}
                    selectedBays={apiData?.selectedBays}
                    splitByShootType={apiData?.splitByShootType}
                    splitByOrder={apiData?.splitByOrder}
                    splitByAssignedModel={apiData?.splitByAssignedModel}
                    includeSpecialCategory={apiData?.includeSpecialCategory}
                    dateString={apiData?.dateString}
                    includePendingAtRawQC={apiData?.includePendingAtRawQC}
                    showOnlyDDApproved={apiData?.showOnlyDDApproved}
                    showCSA={apiData?.showCSA}
                    showSLAPending={apiData?.showSLAPending}
                    splitByPresets={apiData?.splitByPresets}
                    splitByDaysSinceInbound={apiData?.splitByDaysSinceInbound}
                />
            )}
            <Modal
                open={showOrderModal}
                onCancel={() => {
                    setShowOrderModal(false);
                }}
                onOk={HandleDownloadXlsx}
                style={{
                    height: '90vh',
                    minHeight: '70vh',
                    minWidth: '100vw',
                    padding: '0',
                    border: '1px solid red',
                    overflow: 'auto',
                    top: '20px',
                }}
            >
                <div
                    style={{
                        height: '100%',
                        overflow: 'auto',
                        width: '100%',
                    }}
                >
                    <div
                        style={{
                            height: 'calc(100% - 155px)',
                            marginTop: '35px',
                            overflow: 'auto',
                        }}
                    >
                        <CommonTable
                            data={orderTableData?.data}
                            columns={column}
                            loading={{
                                spinning: isFetching,
                                indicator: spinIcon,
                            }}
                            bordered
                            size="small"
                            rowSelection={{
                                type: 'checkbox',
                                onChange: selectedRowKeys => {
                                    setSelectedOrders(selectedRowKeys);
                                },
                            }}
                            rowKey="_id"
                        />
                    </div>
                    <div
                        style={{
                            height: '50px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Pagination
                            current={pageNumber}
                            onChange={page => {
                                setPageNumber(page);
                            }}
                            pageSizeOptions={['10', '20', '50']}
                            total={orderTableData?.totalCount}
                            pageSize={pageSize}
                            defaultPageSize={pageSize}
                            showSizeChanger
                            onShowSizeChange={(current, size) => {
                                setPageSize(size);
                                setPageNumber(1);
                            }}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
}
